var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 22c5.522 0 10-4.478 10-10S17.522 2 12 2 2 6.478 2 12s4.475 10 10 10z", fill: "#2CA01C" }),
    React.createElement("path", { d: "M8.666 8.11A3.89 3.89 0 0 0 4.776 12a3.886 3.886 0 0 0 3.89 3.887h.555v-1.443h-.555A2.445 2.445 0 0 1 6.222 12a2.445 2.445 0 0 1 2.444-2.444H10v7.556c0 .796.647 1.443 1.443 1.443V8.11H8.666zm6.668 7.777a3.888 3.888 0 0 0 0-7.774h-.555v1.443h.555A2.445 2.445 0 0 1 17.778 12a2.445 2.445 0 0 1-2.444 2.444H14V6.888c0-.796-.647-1.443-1.443-1.443v10.442h2.778z", fill: "#fff" })
  );
});